import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { paymentApi } from 'api'
import { useHistory } from 'react-router-dom'

const Callback = (props) => {
  const history = useHistory()

  useEffect(() => {
    paymentApi.onboardSeller().then((res) => history.push('/dashboard/pro'))
  }, [history])

  return <section className="section default_mod_v2 center_mod"></section>
}

const mapStateToProps = ({ auth: { user, error, attributes } }) => ({
  user,
  authError: error,
  attributes,
})

export default connect(mapStateToProps)(Callback)
